import TwoFAManager from '../components/TwoFAManager'
import { createButtonPlugin, showModal } from '../common/helpers'

declare global {
  interface Window {
    mandatory2fa?: boolean
  }
}

export function showDialog(state: 'enable'| 'disable') {
  showModal(TwoFAManager, {
    type: state
  })
}

export default createButtonPlugin('manage-2fa', (element) => {
  const state = element.getAttribute('data-manage-2fa')
  // Typeguard
  if (state !== 'enable' && state !== 'disable') {
    return
  }
  showDialog(state)
})
